"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttendingAccountingsListApiResponseSchema = exports.getAttendingAccountingApiEntitySchema = void 0;
const zod_1 = require("zod");
const doctor_attending_1 = require("../doctor-attendings/doctor-attending");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const office_1 = require("../offices/office");
exports.getAttendingAccountingApiEntitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('attending-accountings'),
    attributes: zod_1.z.object({
        accountingMonth: zod_1.z.number(),
        accountingYear: zod_1.z.number(),
        period: zod_1.z.object({
            from: zod_1.z.coerce.string(),
            to: zod_1.z.coerce.string(),
        }),
        amountFeeCollected: zod_1.z.coerce.number(),
        amountAvailable: zod_1.z.coerce.number(),
        amountCommissionFee: zod_1.z.coerce.number(),
        amountAvailablePaid: zod_1.z.coerce.boolean().default(false),
        feePaid: zod_1.z.coerce.boolean().default(false),
        hasPdfFile: zod_1.z.boolean(),
        createdAt: zod_1.z.coerce.date(),
    }),
    relationships: zod_1.z.object({
        doctorAttending: (0, api_1.apiEntityRelationshipSchema)('doctor-attendings'),
        office: (0, api_1.apiEntityRelationshipSchema)('offices'),
    }),
});
exports.getAttendingAccountingsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getAttendingAccountingApiEntitySchema).merge(zod_1.z.object({
    included: zod_1.z
        .array(zod_1.z.union([doctor_attending_1.simpleDoctorAttendingApiSchema, office_1.simpleOfficeApiSchema]))
        .optional()
        .default([]),
}));
